import React, { useState, useEffect, useRef } from 'react';
import './mobileStyles.scss';

// Custom hook for scroll animations
const useInView = (options = {}) => {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        if (options.once !== false) {
          observer.unobserve(entry.target);
        }
      } else if (options.once === false) {
        setIsInView(false);
      }
    }, {
      threshold: options.threshold || 0.2,
      rootMargin: options.rootMargin || '0px'
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return [ref, isInView];
};

const ScoutifyMobile = () => {
  // Animation refs
  const [logoRef, logoInView] = useInView({ threshold: 0.5, rootMargin: '-30px 0px' });
  const [playersRef, playersInView] = useInView({ threshold: 0.3, rootMargin: '-30px 0px' });
  const [phoneRef, phoneInView] = useInView({ threshold: 0.3, rootMargin: '-30px 0px' });
  const [brandsRef, brandsInView] = useInView({ threshold: 0.3, rootMargin: '-30px 0px' });
  const [descRef, descInView] = useInView({ threshold: 0.4, rootMargin: '-30px 0px' });

  return (
    <section className="scoutify-mobile-section">
      {/* ===== TOP SECTION ===== */}
      <div className="scoutify-mobile-top">
        {/* Logo - centered */}
        <div 
          ref={logoRef}
          className={`logo-container animate-fade-up ${logoInView ? 'is-visible' : ''}`}
        >
          <img 
            src="/2025/scoutify/icons/logo.svg" 
            alt="Scoutify Logo" 
            className="scoutify-logo"
          />
        </div>

        {/* Players image - positioned to the right */}
        <div 
          ref={playersRef}
          className={`players-container animate-fade-up ${playersInView ? 'is-visible' : ''}`}
        >
          <img 
            src="/2025/scoutify/images/players.png" 
            alt="Athletes" 
            className="players-image"
            loading="lazy"
          />
          <img 
            src="/2025/scoutify/icons/yellowBackground.svg" 
            alt="" 
            className="yellow-decoration"
          />
        </div>

        {/* Yellow diagonal decoration */}
        
          
        
      </div>

      {/* ===== YELLOW STRIPE DIVIDER ===== */}
      <div className="yellow-stripe"></div>

      {/* ===== BOTTOM SECTION ===== */}
      <div className="scoutify-mobile-bottom">
        {/* Phone + Brands row */}
        <div className="content-row">
          {/* Phone mockup - left */}
          <div 
            ref={phoneRef}
            className={`phone-container animate-fade-up ${phoneInView ? 'is-visible' : ''}`}
          >
            <img 
              src="/2025/scoutify/icons/phoneScreen.png" 
              alt="Scoutify App Screen" 
              className="phone-mockup"
              loading="lazy"
            />
          </div>

          {/* Brands column - right */}
          <div 
            ref={brandsRef}
            className={`brands-column animate-stagger-brands ${brandsInView ? 'is-visible' : ''}`}
          >
            <img src="/2025/scoutify/icons/adidas.png" alt="Adidas" className="brand-logo" />
            <img src="/2025/scoutify/icons/puma.png" alt="Puma" className="brand-logo" />
            <img src="/2025/scoutify/icons/On.svg" alt="On Running" className="brand-logo on-logo" />
            <img src="/2025/scoutify/icons/wg.png" alt="WMG" className="brand-logo" />
            <img src="/2025/scoutify/icons/wme.png" alt="WME" className="brand-logo" />
          </div>
        </div>

        {/* Description text */}
        <p 
          ref={descRef}
          className={`description-text animate-fade-up ${descInView ? 'is-visible' : ''}`}
        >
          Водещи спортни компании станаха част от доволните клиенти на платформата ни за скаути на спортни таланти. А ние постоянно надграждаме с нови функционалности за повече ефективност и успешни резултати. През новата година продължаваме към постигането на множеството поставени цели чрез здрава работа и иновативно мислене.
        </p>
      </div>
    </section>
  );
};

export default ScoutifyMobile;
